import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>
                When Should You Consider Tekrevol's Magento Development
                Services?
              </h2>
              <p>
                Are you seeking to elevate your online business with customized
                Magento development services? Our expert Magento website
                developers offer tailored solutions, ensuring diverse
                functionality and a seamless customer experience.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Magento Website
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Comprehensive Services</h6>
              <p>
                TekRevol provides comprehensive Magento solutions, handling
                design, development, and continuous support, ensuring a smooth
                end-to-end development experience.
              </p>
            </div>
            <div className="consider-box">
              <h6>Tailored Solutions</h6>
              <p>
                Our experts specialize in crafting customized solutions based on
                unique features, designs, and functionalities that cater
                specifically to your business needs.
              </p>
            </div>
            <div className="consider-box">
              <h6>Competitive Pricing</h6>
              <p>
                We maintain competitive prices without compromising quality,
                offering cost-effective solutions that excel in quality and
                affordability within the market.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
